import { generate } from "library/guid/index.mjs"

export const instanceId = generate()

console.log("My instance", instanceId)
